import { observable, action, runInAction } from 'mobx'
import api from '../api'

class RegistrationStore {
  @observable email = ''
  @observable firstname = ''
  @observable lastname = ''
  @observable password = ''
  @observable passwordRepeat = ''
  @observable code = ''
  @observable gtc = false
  @observable error = undefined
  @observable passwordMessage = 'home_register_password_explanation'
  @observable passwordDefaultMessage = 'home_register_password_explanation'
  @observable codeMessage = ''
  @observable easyplusCode = ''
  @observable easyplusCodeAccepted = false

  @action.bound setEmail(email) {
    this.email = email
  }

  @action.bound setFirstname(firstname) {
    this.firstname = firstname
  }

  @action.bound setLastname(lastname) {
    this.lastname = lastname
  }

  @action.bound setPassword(password) {
    this.password = password
  }

  @action.bound setPasswordRepeat(passwordRepeat) {
    this.passwordRepeat = passwordRepeat
  }

  @action.bound setCode(code) {
    this.code = code
  }

  @action.bound setGtc(gtc) {
    this.gtc = gtc
  }

  @action.bound setPasswordMessage(passwordMessage) {
    this.passwordMessage = passwordMessage
  }

  @action.bound setEasyplusCode(easyplusCode) {
    this.easyplusCodeAccepted = false
    this.easyplusCode = easyplusCode
  }

  @action.bound resetMessages() {
    this.passwordMessage = this.passwordDefaultMessage
    this.codeMessage = ''
  }

  @action.bound setCodeMessage(codeMessage) {
    this.codeMessage = codeMessage
  }

  @action.bound setEasyplusCodeAccepted(accepted) {
    this.easyplusCodeAccepted = accepted
  }

  @action.bound async sendRegistration() {
    try {
      await api.User.createCustomer({
        'email': this.email,
        'firstname': this.firstname,
        'lastname': this.lastname,
        'password': this.password,
        'campaign': this.easyplusCode,
      })
      return false
    } catch(error) {
      this.error = error.response.message

      return this.error
    }
  }

  @action.bound reset() {
    this.email = ''
    this.firstname = ''
    this.lastname = ''
    this.password = ''
    this.passwordRepeat = ''
    this.code = ''
    this.easyplusCode = ''
    this.easyplusCodeAccepted = false
  }
}

export default new RegistrationStore()



// WEBPACK FOOTER //
// ./src/stores/registrationStore.js